import React, { Suspense, lazy } from 'react'
import { useSelector } from 'react-redux'
import Unauthorized from './Unauthorized'

function PRoute({ _comp, _listn, _nex_listn, _nex, _sPath, _toolsState, _user_listn, nex, fr }) {
    const user = useSelector(state=> state.user.user)

    function camelToKebabCase(str) {
      return str.replace(/[A-Z]/g, (match) => '-' + match.toLowerCase()).slice(1);
    }

    let toolName = camelToKebabCase(_comp)


    const toolState =  _toolsState?.tools.find(t => t.tool === toolName)

    let uRoute;

    // Make it so it is not toolName, to include dynamic routes
    switch (toolName) {
      case 'keyword-research':
      case 'competition-research':
      case 'google-search':
      case 'bing-search':
      case 'top-search-queries':
      case 'indexed-pages':
      case 'sitemaps':
      case 'crawlability-test':
      case 'mobile-support-test':
      case 'headers-test':
      case 'speed-test':
      case 'link-analysis':
      case 'keyword-density':
      case 'extract-meta-tags':
      case 'high-quality-backlinks':
      case 'new-backlinks':
      case 'low-quality-backlinks':
      case 'top-referrers':
      case 'page-authority':
      case 'domain-authority':
      case 'content-ideation':
      case 'page-seo-health-test':

        uRoute = false;
        break;
      default:
        uRoute = true;
        break;
    }

    
    const LazyComponent = lazy(()=> import(`./${_comp}`))
  if(uRoute) {
    return (
    <Suspense fallback={'ERROR'}>
        {user? <LazyComponent listn={_listn? _listn: null} nexListn={_nex_listn? _nex_listn: null} nex={_nex? _nex: null} sPath={_sPath? _sPath: null} userListn={_user_listn? _user_listn: null}/> : <Unauthorized />}
    </Suspense>
  )} else if(toolState?.state) {
    return (<Suspense fallback={'ERROR'}>
    {user? <LazyComponent listn={_listn? _listn: null} nexListn={_nex_listn? _nex_listn: null} nex={_nex? _nex: null} sPath={_sPath? _sPath: null} _nex={nex? nex: null} fr={fr? fr: null}/> : <Unauthorized />}
    </Suspense>)
  }
}

export default PRoute